import React from "react";
import { connect } from 'react-redux';
import * as orderActions from "../../redux/actions/orderAction";
import { bindActionCreators } from "redux";
import {fetchContactMechData} from "../../redux/actions/orderAction";
import Barcode from "react-barcode";
import { getShippingLabelAsImage } from "../../api/api";
import { SHIPPING_LABEL_IMG_FORMAT } from "../../AppConfig";
class ReturnInstructions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            returnId: null,
            shippingLabelImage: null,
            shippingLabelConverted: false,
            returnAddress: {},
            loading: true,
        }
        this.imageLabelRef = React.createRef();
    }


    async componentDidMount() {
        this.setState({returnId: this.props.match.params.returnId})
        try{
            await this.props.actions.getRma(this.props.match.params.returnId )
            if(this.props.rmaData.orderMap.shippingLabelUrl){
                let _shippingLabelUrl = this.props.rmaData.orderMap.shippingLabelUrl;
                if(_shippingLabelUrl.indexOf(`${SHIPPING_LABEL_IMG_FORMAT}`) !== -1){ //Check if the label url is already an image
                    this.setState({shippingLabelImage: _shippingLabelUrl})        
                }else{
                    const { imageName } = await getShippingLabelAsImage(this.props.rmaData.orderMap.shippingLabelUrl);
                    this.setState({shippingLabelImage: imageName, shippingLabelConverted: true})
                }
            }

            const returnItem = this.props.rmaData.returnItems[0]
            const returnFacilityId = returnItem.returnFacilityId
            const returnsContactMechId = returnItem.returnsContactMechId

            const returnAddress = await fetchContactMechData({facilityId: returnFacilityId, contactMechId: returnsContactMechId})

            this.setState({
                returnAddress: returnAddress.addressMap
            })
        } catch (err) {
            console.log(err)
        } finally {
            this.setState({loading: false});
        }
    }

    render() {
        const { returnId, shippingLabelImage, shippingLabelConverted, loading } = this.state;
        return (
            <div className="return-instructions-page container">
            <button className="btn btn-primary btn-new" Style="float: right;" onClick={() => window.print()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                    <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                    <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
                </svg> Print</button>
                <br></br>
                <br></br>
                <br></br>
                {/*<div className="row">
                    <div className="col-12">
                        <h3>Instructions for returning:</h3>
                        {this.props.returnInstructions ? (
                            <div dangerouslySetInnerHTML={{ __html: this.props.returnInstructions }}></div>
                        ) : (
                            <ul>
                                <li>Please ship these items to the address listed above.</li>
                                <li>Print out this returns slip and include it with your package.</li>
                                <li>Ship the package via USPS, FedEx, or UPS (we suggest getting a tracking number).</li>
                            </ul>
                        )}
                    </div>
                </div>*/}
                <div className="row">
                    <div className="col-6">
                        {this.props.rmaData &&
                        <React.Fragment>
                            <h3 className="mb-0"><span className="font-weight-bold">Order #</span>{this.props.rmaData.orderMap.orderId}</h3>
                            <Barcode className="barcode" value={this.props.rmaData.orderMap.externalId} height={50} displayValue={false}/>
                        </React.Fragment>
                        }
                    </div>
                    <div className="col-6">
                        <h3 className="mb-0"><span className="font-weight-bold">RMA:</span> #{returnId}</h3>
                        {returnId && <Barcode className="barcode" value={returnId} height={50} displayValue={false}/>}
                    </div>
                    <div className="col-12 my-4">
                        <div>
                            <h5 className="font-weight-bold mb-0">Return Address:</h5>
                            {this.state.returnAddress &&
                            <React.Fragment>
                                {this.state.returnAddress.toName}<br />
                                {this.state.returnAddress.address1}<br />
                                {this.state.returnAddress.city}&nbsp;
                                {this.state.returnAddress.stateProvinceGeoId ? this.state.returnAddress.stateProvinceGeoId.replace('USA_', '') : ''}&nbsp;
                                {this.state.returnAddress.postalCode}
                                <br />
                            </React.Fragment>
                            }
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                    {this.props.rmaData &&
                        <React.Fragment>
                            <table className="order-detail table">
                                <thead>
                                    <tr><th>Item</th><th>Sku</th><th>Return Qty</th><th>Reason</th></tr>
                                </thead>
                                <tbody>
                                    {
                                        this.props.rmaData.returnItems.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item.itemName}&nbsp;{item.color}&nbsp;{item.size}</td>
                                                    <td>{item.sku}</td>
                                                    <td>{item.returnQuantity}</td>
                                                    <td>{item.returnReason}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </React.Fragment>
                        }
                    </div>
                </div>    
                
                <div className="row">
                    <div className="col-12">
                         <h5><span className="font-weight-bold">{shippingLabelImage ? 'Return shipping label' : 'RETURN SHIPPING LABEL - NOT PREPAID. POSTAGE IS REQUIRED'}</span></h5>
                        {shippingLabelImage || loading ? (<p></p>) : (
                            <h5><span style={{color:'red'}} className="font-weight-bold">This is not a prepaid label. Postage is required.</span></h5>
                        )}
                    </div>
                    {loading ? (
                        <div className="col-12 text-center mt-5">
                            <div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div>
                        </div>
                    ) : (
                        <React.Fragment>
                            {shippingLabelImage ? (
                                <div className="col-12">
                                    <div className="shipping-label__wrapper d-flex justify-content-center align-items-center">
                                        <i className="bi bi-scissors"></i>
                                        <img 
                                            src={shippingLabelConverted ? `data:image/png;base64,${shippingLabelImage}` : shippingLabelImage} 
                                            className={`shipping-label__img ${shippingLabelConverted ? 'shipping-label__img--converted' : ''}`}
                                            alt="Return shipping label"
                                        />
                                    </div>                        
                                </div>
                            ) : ( 
                                <div className="col-12">
                                    <div className="shipping-label__wrapper flex-direction-column">
                                        <i className="bi bi-scissors"></i>
                                        <div>
                                            {Boolean(this.props.orderData && this.props.orderData.shipInfoMap) &&
                                                <React.Fragment>
                                                    <div className="d-flex mb-5">
                                                        <p className="font-weight-bold mr-2">FROM:</p>
                                                        <p>
                                                            {this.props.orderData.shipInfoMap.name}<br />
                                                            {this.props.orderData.shipInfoMap.address1}<br />
                                                            {this.props.orderData.shipInfoMap.city}&nbsp;
                                                            {this.props.orderData.shipInfoMap.state}&nbsp;
                                                            {this.props.orderData.shipInfoMap.postalCode}
                                                            <br />
                                                        </p>
                                                    </div>
                                                    <div className="d-flex justify-content-center mb-5" style={{fontSize: '1.2rem'}}>
                                                        <p className="font-weight-bold mr-2">TO:</p>
                                                        <p>
                                                            {this.state.returnAddress.toName}<br />
                                                            {this.state.returnAddress.address1}<br />
                                                            {this.state.returnAddress.city}&nbsp;
                                                            {this.state.returnAddress.stateProvinceGeoId ? this.state.returnAddress.stateProvinceGeoId.replace('USA_', '') : ''}&nbsp;
                                                            {this.state.returnAddress.postalCode}
                                                            <br />
                                                        </p>
                                                    </div>
                                                    <div className="my-2">RMA: #{returnId}</div>
                                                </React.Fragment>
                                            }
                                        </div>
                                    </div>                        
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
};

function mapStateToProps(state) {
    var returnSettingsMap = state.storeSettingData.storeDesign.returnSettingsMap;

    return {
        rmaData: state.orderDataDetails.returnRMAItemDetails,
        orderData: state.orderDataDetails.orderData,
        returnInstructions: returnSettingsMap.returnInstructions,
        returnAddress: returnSettingsMap.returnAddress,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            getRma: bindActionCreators(orderActions.fetchRMAItemDetails, dispatch)
        }
    };
}

export default connect( mapStateToProps, mapDispatchToProps)(ReturnInstructions);



// WEBPACK FOOTER //
// ./src/components/OrderDetails/ReturnInstructions.js